module.exports = __webpack_public_path__ + "static/media/jewelryLogo.c1c418fe.png";